import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ButtonComponent } from './button.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: ButtonComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class ButtonRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/button/button-routing.module.ts